export const IvyKey = {
  dir: 'Éµdir', // Component
  cmp: 'Éµcmp', // Directive
  prov: 'Éµprov' // Serivce
};
